import { MotorStepType, MotorFlowType } from 'scenes/motor/types';
import { stepOrder } from '../../helpers/progress';

// NEW PROGRESS BAR
const carDetailsPharse = stepOrder.slice(0, 5);
export const calculateCarDetailsProgress = (step: MotorStepType) => {
  const f = carDetailsPharse.findIndex((v) => v === step);
  if (f === carDetailsPharse.length - 1) return ((f - 1) / 4) * 100;
  return (f / 4) * 100;
};

const policyDetailsPharse = stepOrder.slice(22, 45);
export const calculatePolicyDetailsProgress = (
  step: MotorStepType,
  flow?: MotorFlowType
) => {
  if (flow === MotorFlowType.AddPolicyHolder) {
    return (
      (policyDetailsPharse.findIndex(
        (v) => v === MotorStepType.AddPolicyHolder
      ) /
        policyDetailsPharse.length) *
      100
    );
  }
  if (step === MotorStepType.addDriverName || step === MotorStepType.Name) {
    return (
      (policyDetailsPharse.findIndex((v) => v === MotorStepType.Name) /
        policyDetailsPharse.length) *
      100
    );
  }
  const f = policyDetailsPharse.findIndex((v) => v === step);
  return (f / policyDetailsPharse.length) * 100;
};

export const shouldShowPreQuote = (flow: MotorFlowType, step: MotorStepType) =>
  flow === MotorFlowType.QuoteDetails ||
  flow === MotorFlowType.AddDriver ||
  (flow === MotorFlowType.CoverOptions && step === MotorStepType.QuotePrice);

export const phraseDetector = (flow: MotorFlowType, step: MotorStepType) => (
  steps: MotorStepType[],
  flows: MotorFlowType[]
) => steps.includes(step) && flows.includes(flow);

export const calculatePhraseProgress = (
  currentStep: MotorStepType,
  currentPhrase: MotorStepType[]
) => {
  const currentStepIndex = currentPhrase.findIndex((v) => v === currentStep);
  return (currentStepIndex / currentPhrase.length) * 100;
};

export const isFlowCompleted = (flow: MotorFlowType, step: MotorStepType) => (
  pivotStep: MotorStepType,
  byPassFlow?: MotorFlowType
) => {
  if (byPassFlow && flow === byPassFlow) return true;
  const stepIndex = stepOrder.findIndex((s) => s === step);
  const pivotStepIndex = stepOrder.findIndex((s) => s === pivotStep);

  return stepIndex >= pivotStepIndex;
};
